export type NameType = 'closed';

export const name: NameType = 'closed';
